














import { Vue, Component, Prop } from 'vue-property-decorator';

import { UserActivationActionTypeEnum } from '../../ActivationAction';

@Component({})
export default class BotFeedbackLimitAlert extends Vue {
  @Prop() keysRecord!: Record<UserActivationActionTypeEnum, string>

  @Prop() type!: UserActivationActionTypeEnum
}
